import '/index.scss';
import Lightbox from './ts/modules/lightbox';
import ScrollTracker from './ts/modules/scroll_tracker';
import ReadMore from './ts/modules/read_more';

import * as Sentry from '@sentry/browser';

function init()
{
  new Lightbox();

  document.querySelectorAll(ReadMore.SELECTOR).forEach((element) => {
    if(element instanceof HTMLElement) {
      new ReadMore(element);
    }
  })

  document.querySelectorAll(ScrollTracker.SELECTOR).forEach((element) => {
    if(element instanceof HTMLElement) {
      new ScrollTracker(element);
    }
  })

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: '/sentry-tunnel',
    environment: import.meta.env.MODE
  });
}

// run once when page loads
if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}